import React from "react";
import "../../assets/css/about.css";
import { motion } from "framer-motion";

export default function About() {
  return (
    <section className="aboutPro">

      <div className="aboutPro-container">

        {/* LEFT SIDE */}
        <div className="about-left">

          <motion.h4
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            Who We Are
          </motion.h4>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            About <span>Trip Word</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            Trip Word is a passionate travel and event management company founded in 2023 
            with a vision to make travel easy, affordable, and memorable.
            <br /><br />
            We specialize in organizing group tours, events, and customized travel experiences 
            across India and international destinations.
          </motion.p>

        </div>

        {/* RIGHT SIDE TIMELINE */}
        <div className="about-right">

          <motion.div 
            className="timeline-item"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
          >
            <div className="dot"></div>
            <div className="content">
              <h3>2023</h3>
              <p>Trip Word was founded with a mission to simplify travel planning.</p>
            </div>
          </motion.div>

          <motion.div 
            className="timeline-item"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
          >
            <div className="dot"></div>
            <div className="content">
              <h3>Our Growth</h3>
              <p>Serving families, corporates, and groups across multiple destinations.</p>
            </div>
          </motion.div>

          <motion.div 
            className="timeline-item"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
          >
            <div className="dot"></div>
            <div className="content">
              <h3>Today</h3>
              <p>Delivering seamless travel experiences with trust & quality.</p>
            </div>
          </motion.div>

        </div>

      </div>

    </section>
  );
}